/**
 * Scheduler API responses: Angular HttpClient returns JSON at root.
 * Legacy $http exposed the same JSON on `response.data`.
 */
export function unwrapSchedulerResponse(response: unknown): Record<string, unknown> {
  if (response == null || typeof response !== 'object') {
    return {};
  }
  const body = response as Record<string, unknown>;
  if (
    'callSuccess' in body ||
    'goldSyncUI' in body ||
    'goldSyncLogHistory' in body ||
    'goldSyncObjDataCount' in body ||
    'addApiDetails' in body ||
    'updateApiDetails' in body
  ) {
    return body;
  }
  const nested = body['data'];
  if (nested != null && typeof nested === 'object') {
    return nested as Record<string, unknown>;
  }
  return body;
}

export function isSchedulerCallSuccess(value: unknown): boolean {
  return value === 1 || value === '1' || value === true;
}

export function isSchedulerCallFailure(value: unknown): boolean {
  return value === 0 || value === '0' || value === false;
}

/** Legacy: `response.data.goldSyncLogHistory` (Angular HttpClient returns body at root). */
export function extractGoldSyncLogHistory(
  response: unknown
): { rows: Record<string, unknown>[]; errorMessage?: string } {
  if (Array.isArray(response)) {
    return { rows: response as Record<string, unknown>[] };
  }
  const data = unwrapSchedulerResponse(response);
  if (isSchedulerCallFailure(data['callSuccess'])) {
    return {
      rows: [],
      errorMessage: String(data['errorMessage'] || 'Failed to load log history'),
    };
  }
  const raw = data['goldSyncLogHistory'];
  if (Array.isArray(raw)) {
    return { rows: raw as Record<string, unknown>[] };
  }
  return { rows: [] };
}
